import { useEffect, useState } from "react";
import { TextField, FormControl } from "@mui/material";
import { useFormik } from "formik";
import Yup from "validation/Validation";
import { useResponseErrorOnly } from "hooks";
import { ArticleSelect, GridFilter } from "components";
import { useMakaleAramaMutation } from "api/search";

const SearchBar = ({ Arama, data, id }) => {
  const [articleId, setarticleId] = useState(0);
  const [MakaleArama, makaleData] = useMakaleAramaMutation();

  const handleOnArtice = (e) => {
    setarticleId(e.target.value);
  };

  const formFields = { title: Yup.string() };
  const validationSchema = Yup.object(formFields);
  const formikConfig = {
    initialValues: { title: "" },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      resetForm();
      let arama = {};
      if (articleId !== 0) {
        arama = {
          title: values.title,
          katid: id,
          articleId: parseInt(articleId),
        };
      } else {
        arama = {
          title: values.title,
          katid: id,
        };
      }

      Arama(arama);
    },
  };

  const { handleSubmit, handleChange, values, errors, resetForm } =
    useFormik(formikConfig);

  useEffect(() => {
    MakaleArama({});
  }, [MakaleArama]);

  useResponseErrorOnly(data);

  return (
    <GridFilter
      data={data}
      newItemUrl={`/detail-product/0/${id}`}
      handleSubmit={handleSubmit}
      title={"Ürün Arama"}
    >
      <div className="grid grid-cols-2 gap-5 mb-4">
        <FormControl fullWidth sx={{ m: 0 }}>
          <TextField
            sx={{ m: 0 }}
            size="small"
            margin="normal"
            required
            fullWidth
            id="title"
            label="Ürün Adı"
            name="title"
            autoComplete="title"
            onChange={handleChange}
            values={values.title}
            helperText={errors.title && errors.title}
            error={errors.title ? true : false}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 0 }}>
          <ArticleSelect
            data={makaleData}
            articleId={articleId}
            handleOnChange={handleOnArtice}
          />
        </FormControl>
      </div>
    </GridFilter>
  );
};

export default SearchBar;
